import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/farmacia`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioAltoCustoRetiradaPendente(queryParms) {

            return repository.get(`${baseUrl}/relatorio-alto-custo-retirada-pendente?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioDispensacao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-dispensacao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioDispensacaoRemedioCasa(queryParms) {

            return repository.get(`${baseUrl}/relatorio-dispensacao-remedio-casa?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioAltoCustoProcesso(queryParms) {

            return repository.get(`${baseUrl}/relatorio-alto-custo-processo?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
